import React, {
  useCallback, useContext, useEffect, useMemo, useRef, useState,
} from 'react';
import {
  Alert, AlertTitle, Box, Button,
} from '@mui/material';

import CircularProgressWithLabel from './progressBar';
import DKSUDates from './DKSUDates';
import DKSUData from './DKSUData';
import { AppContext } from '../../../providers/authProvider';
import { LogicaContext } from '../../../providers/authLogicaProvider';
import {
  getDateStr, LOGIKA_URL_DATA, dateToUpload, DATATYPES,
} from './consts';
import { checkTask } from '../../../api/checktask';
import { Modal } from '../../../components/Styled/Misc/Modal';
import { CloseButton } from '../../../components/Styled/Buttons';
import LoginInLogica from '../loginInLogica/editor';
import LogicaPing from '../Ping';
import Loader from '../../../components/MaterialUI/loader';
import { downloadFileFromJSON } from '../../../api/utils';

function Editor() {
  const [dataType, setDataType] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear()
    .toString());
  const [date, setDate] = useState(null);
  const [period, setPeriod] = useState({
    start: null,
    end: null,
  });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [res, setRes] = useState(null);
  const [show, setShow] = useState(false);
  const [modalLogicaLogin, setModalLogicaLogin] = useState(false);
  const [datesRes, setDatesRes] = useState(null);
  const [logicaPingSuccess, setLogicaPingSuccess] = useState(true);
  const [isUploadAll, setUploadAll] = useState(false);
  const [selectKDB, setSelectKDB] = useState({ code: '' });
  const progessBar = useRef({
    total: 0,
    now: 0,
  });

  const { auth } = useContext(AppContext);
  const token = auth().access;
  const {
    ticket,
    setTicket,
  } = useContext(LogicaContext);

  useEffect(() => {
    if (!ticket || err === '401 ' || err === 'Помилка сервера - 401') {
      setTicket(null);
      setShow(false);
      setModalLogicaLogin(true);
      setErr(null);
      return;
    }
    setModalLogicaLogin(false);
  }, [err, setTicket, ticket]);

  const onStart = useCallback(() => {
    setLoading(true);
    setErr(null);
    setRes(null);
    setDatesRes(null);
  }, []);

  const onEnd = useCallback(() => {
    setLoading(false);
  }, []);

  const onError = useCallback((e) => {
    setLoading(false);
    setErr(e);
  }, []);

  const onDone = useCallback((r) => {
    setLoading(false);
    setRes(r);
  }, []);

  const keyAll = 'Всі';

  const periodAvailable = datesRes && dataType && datesRes[dataType].period_avilable;

  const datesByType = useMemo(
    () => {
      const displayName = (datesRes && dataType) ? datesRes[dataType].available
        .map((data) => ({
          value: getDateStr(data.datefile),
          display_name: getDateStr(data.datefile),
        })) : [];

      return displayName || [];
    },
    [dataType, datesRes],
  );

  const getDKSUData = useCallback((toExcel = false) => {
    const loader = async (datetimes, loadDataTape) => {
      const params = {
        datetimes,
        attachedBudgets: false,
        ticket,
        year: year || new Date().getFullYear(),
        selectKDB: (selectKDB === null) ? '' : selectKDB.code,
        save_to_excel: toExcel,
      };

      params.datatype = loadDataTape;

      const r = await fetch(`${LOGIKA_URL_DATA}`, {
        method: 'POST',
        headers:
                    {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${token}`,
                    },
        body: JSON.stringify(params),
      });

      if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
      // eslint-disable-next-line camelcase
      const { task_id } = await r.json();
      // eslint-disable-next-line camelcase
      return task_id;
    };
    progessBar.current = {
      total: 0,
      now: 0,
    };
    onStart();

    const loadDataAsync = (dt, loadDataTape, resolve, reject) => loader(dt, loadDataTape)
      .then((d) => checkTask(
        d,
        auth,
        (r) => {
          if (r.result.errors) {
            onError(`${r.result.errors[0]}  ${dt} ${loadDataTape}`);
          } else {
            if (r.result.file) downloadFileFromJSON(r.result.file, r.result.filename);
            if (isUploadAll) {
              progessBar.current = {
                ...progessBar.current,
                now: progessBar.current.now + 1,
              };
            }
          }
          if (typeof dt === 'string') {
            onDone(`Дані ${loadDataTape} за ${dt.slice(0, 10).replace('/./gi', '-')}  завантажено успішно!`);
          } else if (Array.isArray(dt)) {
            onDone(`Дані ${loadDataTape} за ${dt[0].replace('/./gi', '-')}  завантажено успішно!`);
          } else onDone(`Дані ${loadDataTape} завантажено успішно!`);
          if (r.status !== 'PENDING') {
            onEnd();
          }
          if (resolve) resolve(d);
        },
        (e) => {
          onError(e ? e.message : 'Скасовано');
          if (reject) reject(e);
        },
      ))
      .catch((e) => {
        onError(`${e.message} ${dt} ${loadDataTape}`);
      });

    const loadTypes = DATATYPES.filter((e) => {
      if (dataType === 'FT110') return (e === dataType);
      if (toExcel && (dataType === '@B')) return (e === dataType);
      return (e !== keyAll);
      // eslint-disable-next-line array-callback-return,consistent-return
    });

    if (isUploadAll) {
      const periodStart = Date.parse(new Date(dateToUpload(period.start)));
      const periodEnd = Date.parse(new Date(dateToUpload(period.end)));

      // const arrDt = datesRes[dataType].available;
      // eslint-disable-next-line array-callback-return,consistent-return
      const total = 2 * datesByType.reduce((sum, el) => {
        const currentDt = Date.parse(new Date(dateToUpload(el.value)));
        if ((currentDt >= periodStart) && (currentDt <= periodEnd)) {
          return sum + 1;
        }
        return sum;
      }, 0);

      progessBar.current = {
        ...progessBar.current,
        total: progessBar.current.total + total,
      };

      datesByType.map((el) => loadTypes.reduce(async (previousPromise, loadDataTape) => {
        const currentDt = Date.parse(new Date(dateToUpload(el.value)));

        if ((currentDt >= periodStart) && (currentDt <= periodEnd)) {
          await previousPromise;

          const resLoad = new Promise((resolve, reject) => {
            loadDataAsync(dateToUpload(el.value), loadDataTape, resolve, reject);
          });
          return resLoad;
        }
        return Promise.resolve();
      }, Promise.resolve()));
    } else {
      // eslint-disable-next-line array-callback-return
      loadTypes.map((loadDataTape) => {
        const sd = new Date(period.start);
        const ed = new Date(period.end);

        const datetimes = periodAvailable
          ? datesRes[dataType].available
            .map((d) => new Date(d.datefile))
            .filter((d) => d >= sd && d <= ed)
            .map((d) => d.toJSON()
              .substring(0, 10)) : [dateToUpload(date)];
        loadDataAsync(datetimes, loadDataTape);
      });
    }
  }, [auth, dataType, date, datesByType, datesRes, isUploadAll, onDone, onEnd, onError, onStart, period.end, period.start, periodAvailable, selectKDB, ticket, token, year]);

  const getDKSUDates = useCallback(() => {
    const loader = async () => {
      const response = await fetch(`${LOGIKA_URL_DATA}?ticket=${ticket}&year=${year}`, {
        method: 'GET',
        headers:
          {
            Authorization: `Bearer ${token}`,
          },
      });

      if (!response.ok) {
        throw new Error(`${response.status} ${response.statusText}`);
      }
      const data = await response.json();
      return data;
    };

    const addAll = (data) => {
      const resData = {};

      const ft110Available = data.FT110.available;
      const dataAll = data['@B'].available.reduce((prev, el) => {
        const { datefile } = el;

        const datefileFt110 = ft110Available.filter((elFt110) => (elFt110.datefile === datefile));

        return [
          ...prev,
          ...datefileFt110,
        ];
      }, []);

      resData[keyAll] = {
        available: dataAll,
        period_avilable: data.FT110.period_avilable && data['@B'].period_avilable,
        current: (data['@B'].current === data.FT110.current) ? data.FT110.current : '',
      };

      setPeriod({
        start: getDateStr(resData[keyAll].available[0].datefile),
        end: getDateStr(resData[keyAll].available[resData[keyAll].available.length - 1].datefile),
      });

      return Object.assign(resData, data);
    };

    onStart();
    loader()
      .then(
        (data) => {
          setDatesRes(addAll(data));
          onEnd();
        },
        (e) => {
          onError(e ? e.message : 'Скасовано');
        },
      )
      .catch((e) => {
        onError(e.message);
        onEnd();
      });
  }, [onEnd, onError, onStart, ticket, token, year]);

  const lastDownload = datesRes && dataType && ((datesRes[dataType] && getDateStr(datesRes[dataType].current)) || '-');

  return (
    <>
      <LogicaPing available={logicaPingSuccess} handleAvailable={setLogicaPingSuccess} />
      <Box display="flex" sx={{ mb: 2 }}>
        <Button
          onClick={() => setShow(true)}
          color="info"
          variant="contained"
          disabled={!logicaPingSuccess}
        >
          Оновити з додатковими налаштуваннями
        </Button>
      </Box>

      {res && <Alert severity="success"><AlertTitle>{res}</AlertTitle></Alert>}
      {res && isUploadAll && (<CircularProgressWithLabel progess={progessBar.current} />)}
      {err && <Alert severity="error"><AlertTitle>{err}</AlertTitle></Alert>}
      {loading && (
      <Loader text="Завантаження" />
      )}

      <Modal open={modalLogicaLogin}>
        <>
          <h3>Авторизація в Логіці</h3>
          <LoginInLogica />
          <div style={{ width: '300px' }}>
            <CloseButton onClick={() => {
              setModalLogicaLogin(false);
            }}
            />
          </div>
        </>
      </Modal>

      {show && (

      <DKSUDates
        year={year}
        setYear={setYear}
        getDKSUDates={getDKSUDates}
        datesRes={datesRes}
        logicaPingSuccess={logicaPingSuccess}
      />
      )}
      {show && datesRes && (
        <DKSUData
          dataType={dataType}
          setDataType={setDataType}
          date={date}
          setDate={setDate}
          getDKSUData={getDKSUData}
          datesByType={datesByType}
          lastDownload={lastDownload}
          logicaPingSuccess={logicaPingSuccess}
          period={period}
          onSetPeriod={setPeriod}
          periodAvailable={periodAvailable}
          selectKDB={selectKDB}
          setSelectKDB={setSelectKDB}
          uploadAll={
            {
              isUploadAll,
              setUploadAll,
            }
          }
        />
      )}
    </>
  );
}
export default Editor;
